/* eslint-disable no-unused-vars */
import { creativesActions } from 'store/campaign/creatives';
import { DeleteIcon } from 'assets/icons';
import * as S from './ImageMediaUpload.styled';
import { Label, CustomTooltip } from 'components';
import Upload from './Upload';
import { useDispatch, useSelector } from 'react-redux';
import { MEDIATYPES } from 'constants';
import { Question } from 'assets/icons';

const toolTipStyle = {
  color: '#64748B',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '16px',
};

const checkImgData = (iconData) => {
  if (!iconData) return '';
  if (iconData.includes('base64')) {
    return iconData;
  } else {
    return `https://cdn.appnext.com/banner/${iconData}`;
  }
};

const mediaUrl = 'https://cdn.appnext.com/banner/';

export function ImageMediaUploadContainer() {
  const urlCheck = 'cdn.appnext.com';
  const dispatch = useDispatch();
  const selectedIcon = useSelector((state) => state.creatives.selectedCreative?.icon);

  const selectedLandscape = useSelector((state) => state.creatives.selectedCreative?.image);
  const selectedLandscapeVideo = useSelector((state) => {
    if (state.creatives.selectedCreative?.video_landscape) {
      if (state.creatives.selectedCreative?.video_landscape?.includes(urlCheck)) {
        return state.creatives.selectedCreative.video_landscape;
      } else {
        return mediaUrl + state.creatives.selectedCreative.video_landscape;
      }
    }
    return '';
  });
  const selectedPortraitVideo = useSelector((state) => {
    if (state.creatives.selectedCreative?.video_portrait) {
      if (state.creatives.selectedCreative?.video_portrait?.includes(urlCheck)) {
        return state.creatives.selectedCreative?.video_portrait;
      } else {
        return mediaUrl + state.creatives.selectedCreative?.video_portrait;
      }
    }
    return '';
  });

  return (
    <S.GridContainer>
      <div>
        <div>
          <S.LabelBox>
            <Label text='Icon:' variant='label' />
            <CustomTooltip
              style={toolTipStyle}
              content={<Question />}
              text={
                <p style={{ maxWidth: '150px' }}>
                  JPEG or PNG. Please upload image size 512*512. You can also upload different image
                  size and adjust it.
                </p>
              }
            />
          </S.LabelBox>
          {selectedIcon ? (
            <S.WrapForError>
              <S.ImageContainer>
                <S.IconBox>
                  <S.IconWrap>
                    <S.DeleteBtn
                      type='button'
                      onClick={() =>
                        dispatch(
                          creativesActions.updateProperty({
                            propField: 'icon',
                            newValue: null,
                          }),
                        )
                      }
                    >
                      <DeleteIcon />
                    </S.DeleteBtn>
                    <img
                      src={checkImgData(selectedIcon)}
                      alt={'ICON'}
                      width='128px'
                      height='128px'
                      loading='lazy'
                    />
                  </S.IconWrap>
                </S.IconBox>
              </S.ImageContainer>
            </S.WrapForError>
          ) : (
            <div>
              <Upload
                maxWidth={128}
                maxHeight={128}
                error={Boolean(!selectedIcon)}
                errorText='This field is required'
                size='Big'
                fileType={MEDIATYPES.IMAGE}
                onChange={() =>
                  dispatch(
                    creativesActions.updateProperty({
                      propField: 'icon',
                      newValue: '',
                    }),
                  )
                }
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <div>
          <S.LabelBox>
            <Label text='Landscape image:' variant='label' />
            <CustomTooltip
              style={toolTipStyle}
              content={<Question />}
              text={
                <p style={{ maxWidth: '150px' }}>
                  JPEG or PNG. Please upload image size 1200*628. You can also upload different
                  image size and adjust it.
                </p>
              }
            />
          </S.LabelBox>
          {selectedLandscape ? (
            <S.WrapForError>
              <S.ImageContainer>
                <S.IconBox>
                  <S.IconWrap>
                    <S.DeleteBtn
                      type='button'
                      onClick={() =>
                        dispatch(
                          creativesActions.updateProperty({
                            propField: 'image',
                            newValue: '',
                          }),
                        )
                      }
                    >
                      <DeleteIcon />
                    </S.DeleteBtn>
                    <img
                      src={checkImgData(selectedLandscape)}
                      alt={'ICON'}
                      width='227px'
                      height='128px'
                      loading='lazy'
                    />
                  </S.IconWrap>
                </S.IconBox>
              </S.ImageContainer>
            </S.WrapForError>
          ) : (
            <div>
              <Upload
                error={Boolean(!selectedLandscape)}
                errorText='This field is required'
                maxWidth={270}
                maxHeight={270}
                size='Big'
                fileType={MEDIATYPES.IMAGE_LANDSCAPE}
                onChange={() =>
                  dispatch(
                    creativesActions.updateProperty({
                      propField: 'image',
                      newValue: '',
                    }),
                  )
                }
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <div>
          <S.LabelBox>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <Label text='Landscape video:' variant='label' />
              <Label text='Optional' variant='description' />
            </div>
            <CustomTooltip
              style={toolTipStyle}
              content={<Question />}
              text={
                <p style={{ maxWidth: '150px' }}>
                  You can upload a video no less than 10 seconds and no more than 60 seconds.Please
                  upload MP4 video file
                </p>
              }
            />
          </S.LabelBox>
          {selectedLandscapeVideo ? (
            <S.ImageContainer>
              <S.IconBox>
                <S.IconWrap>
                  <S.DeleteBtn
                    type='button'
                    onClick={() =>
                      dispatch(
                        creativesActions.updateProperty({
                          propField: MEDIATYPES.VIDEO_LANDSCAPE_URL,
                          newValue: '',
                        }),
                      )
                    }
                  >
                    <DeleteIcon />
                  </S.DeleteBtn>
                  <video key={selectedLandscapeVideo} width='100%' height='100%' controls>
                    <source src={selectedLandscapeVideo} type='video/mp4' />
                  </video>
                </S.IconWrap>
              </S.IconBox>
            </S.ImageContainer>
          ) : (
            <div>
              <Upload
                maxWidth={270}
                maxHeight={270}
                size='Big'
                fileType={MEDIATYPES.VIDEO_LANDSCAPE_URL}
                onChange={() =>
                  dispatch(
                    creativesActions.updateProperty({
                      propField: MEDIATYPES.VIDEO_LANDSCAPE_URL,
                      newValue: '',
                    }),
                  )
                }
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <div>
          <S.LabelBox>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <Label text='Portrait video:' variant='label' />
              <Label text='Optional' variant='description' />
            </div>
            <CustomTooltip
              style={toolTipStyle}
              content={<Question />}
              text={
                <p style={{ maxWidth: '150px' }}>
                  You can upload a video no less than 10 seconds and no more than 60 seconds.Please
                  upload MP4 video file
                </p>
              }
            />
          </S.LabelBox>

          {selectedPortraitVideo ? (
            <S.ImageContainer>
              <S.IconBox>
                <S.IconWrap>
                  <S.DeleteBtn
                    type='button'
                    onClick={() =>
                      dispatch(
                        creativesActions.updateProperty({
                          propField: MEDIATYPES.VIDEO_PORTRAIT_URL,
                          newValue: '',
                        }),
                      )
                    }
                  >
                    <DeleteIcon />
                  </S.DeleteBtn>
                  <video key={selectedPortraitVideo} width='100%' height='100%' controls>
                    <source src={selectedPortraitVideo} type='video/mp4' />
                  </video>
                </S.IconWrap>
              </S.IconBox>
            </S.ImageContainer>
          ) : (
            <div>
              <Upload
                maxWidth={270}
                maxHeight={270}
                size='Big'
                fileType={MEDIATYPES.VIDEO_PORTRAIT_URL}
                onChange={() =>
                  dispatch(
                    creativesActions.updateProperty({
                      propField: MEDIATYPES.VIDEO_PORTRAIT_URL,
                      newValue: '',
                    }),
                  )
                }
              />
            </div>
          )}
        </div>
      </div>
    </S.GridContainer>
  );
}
